const doc = [({"da":({"js":({"activities":({"show":({"surveys_connected_with_activity":"Spørgeskemaer tilknyttet %{activity_name}"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;